import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';
import { UnavailableLineItem } from '../layout/UnavailableLineItem.js';

const UnavailableLineItemsContainer = ({ unavailableLineItems , labels  })=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !!(unavailableLineItems === null || unavailableLineItems === void 0 ? void 0 : unavailableLineItems.length) && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        component: "h2",
        className: "cart__unavailable-title"
    }, labels.unavailableTitle), unavailableLineItems.map((lineItem)=>/*#__PURE__*/ React.createElement(UnavailableLineItem, {
            key: lineItem.id,
            lineItem: lineItem
        })
    )));
};

export { UnavailableLineItemsContainer };
//# sourceMappingURL=UnavailableLineItemsContainer.js.map
